export const getPortalBase = user => {
  const role = user?.roles?.[0]?.toUpperCase();
  if (role === "SUPER_ADMIN") return "/super_admin";
  if (role === "TEACHER") return "/teacher";
  if (role === "STUDENT") return "/student";
  return "/admin";
};

export const canRenewSubscription = user =>
  ["PRINCIPAL", "SCHOOL_ADMIN", "ADMIN"].includes(user?.roles?.[0]?.toUpperCase());

export const isSubscriptionRestricted = user => {
  if (!user || user.roles?.[0]?.toUpperCase() === "SUPER_ADMIN") return false;
  const status = user.subscriptionStatus?.toUpperCase();
  return ["EXPIRED", "PAYMENT_REQUIRED"].includes(status) ||
    (user.trialExpired === true && status !== "ACTIVE");
};

export const isSubscriptionSafePath = (user, pathname) => {
  const base = getPortalBase(user);
  return [
    `${base}/dashboard`,
    `${base}/profile`,
    "/support",
    "/how-it-works",
    "/setting/change-password",
    ...(canRenewSubscription(user) ? ["/admin/setup/pricing"] : []),
  ].includes(pathname.replace(/\/+$/, ""));
};
